export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">投稿咨询</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            有好的剧集推荐或内容投稿？欢迎联系我们
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200/70">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
              <div className="flex flex-col items-center gap-3 p-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-mail-line text-xl text-primary-500"></i>
                </div>
                <h3 className="font-heading text-foreground-900 text-base">投稿邮箱</h3>
                <p className="text-foreground-500 text-sm">tougao@99ys.com</p>
              </div>
              <div className="flex flex-col items-center gap-3 p-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-wechat-line text-xl text-accent-500"></i>
                </div>
                <h3 className="font-heading text-foreground-900 text-base">官方微信</h3>
                <p className="text-foreground-500 text-sm">久久影视官方</p>
              </div>
              <div className="flex flex-col items-center gap-3 p-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-customer-service-2-line text-xl text-secondary-500"></i>
                </div>
                <h3 className="font-heading text-foreground-900 text-base">在线客服</h3>
                <p className="text-foreground-500 text-sm">工作日 9:00-18:00</p>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-background-200/70">
              <p className="text-center text-foreground-500 text-sm">
                如果你是影视创作者或内容提供方，欢迎通过以上方式联系我们，久久影视期待与你合作，共同为剧迷带来更多优质电视剧全集免费在线观看体验。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}